import { render, staticRenderFns } from "./MensagensVetoPorEnteFederativoPorAno.vue?vue&type=template&id=b8edd7d0&scoped=true"
import script from "./MensagensVetoPorEnteFederativoPorAno.vue?vue&type=script&lang=js"
export * from "./MensagensVetoPorEnteFederativoPorAno.vue?vue&type=script&lang=js"
import style0 from "./MensagensVetoPorEnteFederativoPorAno.vue?vue&type=style&index=0&id=b8edd7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8edd7d0",
  null
  
)

export default component.exports